import { useAuth } from "@/_core/hooks/useAuth";
import { isMarketingRole, isPathAllowedForMarketing } from "@shared/userRoles";
import { useEffect } from "react";
import { useLocation } from "wouter";

/** Redirect marketing users away from disallowed staff routes. */
export default function MarketingRouteGuard({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (loading || !user || !isMarketingRole(user.role)) return;
    if (!isPathAllowedForMarketing(location)) {
      setLocation("/admin/articles");
    }
  }, [loading, user, location, setLocation]);

  return <>{children}</>;
}
